import { Box, Typography, Button, Select, MenuItem, InputLabel, TextField } from "@mui/material";
import React, { useEffect, useState } from "react"
import style from "./style";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import { ReactComponent as Download } from "../../../../../assets/AccountingModule/bill_download.svg";
import { ReactComponent as Send } from "../../../../../assets/AccountingModule/bill_send.svg";
import dropDownIcon from '../../../../../assets/AccountingModule/dropdown_black.svg'
import deleteIcon from "../../../../../assets/AccountingModule/delete.svg";
import editIcon from "../../../../../assets/AccountingModule/edit2.svg";
import Modal from "../../../../../components/Modal";
import { formatDate } from "../../../../../utils/DateFormat";

const PurchaseView = ({ handleDownload, handleShowPdf, handleSendBill, data, handleSubmitData, paymentList, deleteRefundHistory, status }) => {
  const bill = useLocation().state.item;
  const [billHtml, setBillHtml] = useState("")
  const [isTableVisible, setIsTableVisible] = useState(true);
  const [open, setOpen] = useState(false);
  const [type, setType] = useState("");
  const [bank, setBank] = useState("");
  const [bankId, setBankId] = useState("");
  const [invoicePayDate, setInvoicePayDate] = useState(dayjs());
  const [amount, setAmount] = useState("");
  const [reference, setReference] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [currentPaymentId, setCurrentPaymentId] = useState(null);
  const [editingRefund, setEditingRefund] = useState(null);

  useEffect(() => {
    if (editingRefund) {
      setType(editingRefund.method || "");
      setBankId(editingRefund.account || "");
      setAmount(editingRefund.amount || "");
      setReference(editingRefund.reference || "");
      setCurrentPaymentId(editingRefund.transactionId || null);
      setIsEditing(true);

      if (editingRefund.date) {
        setInvoicePayDate(dayjs(editingRefund.date));
      }
      if (editingRefund.account) {
        const selectedBank = data.find(b => b._id === editingRefund.account);
        setBank(selectedBank?.bankName || "");
      }
    }
  }, [editingRefund]);

  useEffect(() => {
    let isMounted = true;
    const fetchBill = async () => {
      try {
        const result = await handleShowPdf();
        if (isMounted) {
          setBillHtml(result.__html);
        }
      } catch (error) {
        console.error("Error fetching bill:", error);
      }
    };
    fetchBill();
    return () => {
      isMounted = false;
    };
  }, [handleShowPdf]);

  const handleSendInvoice = () => {
    handleSendBill();
  };

  const resetForm = () => {
    setIsEditing(false);
    setCurrentPaymentId(null);
    setInvoicePayDate(dayjs());
    setType("");
    setBank("");
    setBankId("");
    setAmount("");
    setReference("");
  };

  const handleCheck = async () => {
    const numericAmount = parseFloat(amount);
    const payload = {
      date: invoicePayDate.toISOString(),
      type,
      amount: numericAmount,
      reference,
      ...(type === "Bank" && { bankId }),
      ...(type === "Cash" && { bankId: "" }),
      ...(isEditing && { transactionId: currentPaymentId })
    };
    setOpen(false);
    resetForm();
    handleSubmitData(payload, isEditing);
  };

  const handleRecordPayment = () => {
    resetForm();
    setOpen(true);
  };

  const handleRefund = (refundItem = null) => {
    setEditingRefund(refundItem);
    setOpen(true);
  };

  const deleteRefund = (id) => {
    deleteRefundHistory(id);
  };

  return (
    <>
      <Box sx={style.mainGrid}>
        <Typography variant="h5" sx={style.leaveHeading}>
          {"Bill Details"}
        </Typography>
        <Box sx={style.textGrid}>
          <Button
            variant="contained"
            color="success"
            sx={style.downloadBtns}
            onClick={handleDownload}
          >
            <Download />
            {"Download"}
          </Button>
          {(status !== "draft" || status !== "paid") && (
            <Button
              variant="contained"
              color="success"
              sx={{ ...style.checkinBtn, borderLeft: "1px solid #fff" }}
              onClick={handleRecordPayment}
            >
              Record Payment
            </Button>
          )}
          <Button
            variant="contained"
            color="success"
            sx={{ ...style.checkinBtns, borderLeft: "1px solid #fff" }}
            onClick={handleSendInvoice}
          >
            <Send />
            Send Bill
          </Button>
        </Box>
      </Box>
      <Box sx={{ mt: 2 }}>
        <Box sx={style.paymentSection}>
          <Box sx={style.paymentHeader}>
            <Box sx={style.paymentTitleContainer}>
              <Typography sx={style.paymentTitle}>Payments Made</Typography>
              <Typography sx={style.paymentCount}>{Array.isArray(paymentList) ? paymentList.length : 0}</Typography>
            </Box>
            <Box>
              <button
                type="button"
                style={style.dropDownButton}
                aria-label="Open payment options"
                onClick={() => setIsTableVisible(prev => !prev)}
              >
                <img src={dropDownIcon} alt="Dropdown Icon" style={{
                  transform: isTableVisible ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease"
                }} />
              </button>
            </Box>
          </Box>
          {isTableVisible && (
            <Box sx={{ overflowX: "auto" }}>
              <table style={style.table}>
                <thead style={{ background: "transparent !important", borderBottom: '1px solid #D9D9D9' }}>
                  <tr>
                    <th style={{ ...style.tableHeader, backgroundColor: 'transparent' }}>Date</th>
                    <th style={{ ...style.tableHeader, backgroundColor: 'transparent' }}>Reference</th>
                    <th style={{ ...style.tableHeader, backgroundColor: 'transparent' }}>Payment Mode</th>
                    <th style={{ ...style.tableHeader, backgroundColor: 'transparent' }}>Amount</th>
                    <th style={{ ...style.tableHeader, backgroundColor: 'transparent' }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(paymentList) && paymentList.length > 0 ? (
                    paymentList.map((item, index) => {
                      return (<tr key={index}>
                        <td style={{ ...style.tableCell, borderBottom: "none" }}>
                          {item?.date ? formatDate(item.date) : "N/A"}
                        </td>
                        <td style={{ ...style.tableCell, borderBottom: "none" }}>
                          {item?.reference || "N/A"}
                        </td>
                        <td style={{ ...style.tableCell, borderBottom: "none" }}>
                          {item?.method || "N/A"}
                        </td>
                        <td style={{ ...style.tableCell, borderBottom: "none" }}>
                          {item?.amount ?? "N/A"}
                        </td>
                        <td style={{ ...style.tableCell, borderBottom: "none" }}>
                          <Button type="button" sx={{
                            backgroundColor: "transparent",
                            paddingRight: "0px",
                          }} onClick={() => handleRefund(item)}>
                            <img src={editIcon} alt="Edit" />
                          </Button>
                          <Button type="button" sx={{
                            backgroundColor: "transparent",
                            marginLeft: "-10px",
                          }} onClick={() => {
                            deleteRefund(item?.transactionId);
                          }}>
                            <img src={deleteIcon} alt="Delete" />
                          </Button>
                        </td>
                      </tr>);
                    })
                  ) : (
                    <tr>
                      <td colSpan={5} style={{ textAlign: "center", padding: "12px" }}>
                        No payments found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </Box>
          )}
        </Box>
      </Box>
      <Box sx={style.whiteSection}>
        <Box dangerouslySetInnerHTML={{ __html: billHtml }} />
      </Box>
      <Modal
        open={open}
        setOpen={(value) => {
          setOpen(value);
          if (!value) {
            resetForm();
          }
        }}
        btnText={"Send"}
        title={"Record Payment"}
        handleCheck={handleCheck}
      >
        <Box>
          <Box sx={style.inputGrids}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <InputLabel sx={style.label}>Payment Date</InputLabel>
              <DatePicker
                value={invoicePayDate}
                // minDate={dayjs(item?.invoiceDate)}
                maxDate={dayjs()}
                onChange={(newValue) => { setInvoicePayDate(newValue) }}
                sx={style.dateInput}
                slotProps={{
                  field: {
                    readOnly: true
                  }
                }} />
            </LocalizationProvider>
          </Box>
          <Box sx={style.inputGrids}>
            <InputLabel sx={style.labels}>Type</InputLabel>
            <Select
              value={type || ""}
              onChange={(e) => {
                setType(e.target.value);
                if (e.target.value !== "Bank") {
                  setBank("");
                }
              }}
              name="type"
              sx={style.hoursInput}
              displayEmpty
              renderValue={(selected) =>
                selected ? (
                  selected
                ) : (
                  <span style={{ color: "#999" }}>
                    Select Transaction Type
                  </span>
                )
              }
            >
              <MenuItem sx={style.dropDownMenu} value="Cash">
                Cash
              </MenuItem>
              <MenuItem sx={style.dropDownMenu} value="Bank">
                Bank
              </MenuItem>
            </Select>
          </Box>
          <Box sx={style.inputGrids}>
            <InputLabel sx={style.labels}>Bank</InputLabel>
            <Select
              value={bank || ""}
              disabled={type !== "Bank"}
              name="bank"
              onChange={(e) => {
                setBankId(e.target.value);
                const selectedBank = data.find(b => b._id === e.target.value);
                setBank(selectedBank?.bankName || "");
              }}
              sx={style.hoursInput}
              displayEmpty
              renderValue={(selected) =>
                selected ? (
                  selected
                ) : (
                  <span style={{ color: "#999" }}>
                    Select Bank
                  </span>
                )
              }
            >
              {data?.map((bank) => (
                <MenuItem key={bank._id} value={bank._id}>
                  {`${bank?.bankName} - ${bank.accountNumber?.slice(-4)}`}
                </MenuItem>
              ))}
            </Select>
          </Box>
          <Box sx={style.inputGrids}>
            <InputLabel sx={{ ...style.labels }}>Reference</InputLabel>
            <TextField
              name="bankId"
              placeholder="Enter Reference"
              value={reference}
              sx={style.hoursInput}
              onChange={(e) => setReference(e && e.target ? e.target.value : "")}
            />
          </Box>
          <Box sx={style.inputGrids}>
            <InputLabel sx={style.labels}>Amount</InputLabel>
            <TextField
              value={amount}
              type="number"
              sx={style.hoursInput}
              onChange={(e) => {
                const enteredValue = Number(e.target.value);
                if (!isNaN(enteredValue) && enteredValue >= 0 && enteredValue <= bill?.amountDue) {
                  setAmount(enteredValue);
                } else if (enteredValue === 0 || e.target.value === "") {
                  setAmount("");
                }
              }}
              name="amount"
              placeholder="Enter Amount"
            />
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default PurchaseView;